<template>
    <div>
        <zm-row>
            <zm-button size="small" @click="showCreate()" class="btn-in-line" v-if="role === 'SUPER_ADMIN'" type="primary">create cluster</zm-button>
            <zm-button size="small" @click="fetchData()" class="btn-in-line" plain>show all</zm-button>
            <zm-button size="small" @click="showMQ()" class="btn-in-line" plain :loading="mqLoading">upload from asyncmq</zm-button>
            <zm-button size="small" @click="showSearch()" class="btn-in-line" plain>search by tags</zm-button>
            <zm-input size="small" placeholder="input to search" v-model.trim="search" class="search-input"></zm-input>
        </zm-row>
        <div class="table-container">
            <zm-table resizable border :data="tableData.slice((pageable.pageNumber - 1) * pageable.pageSize, pageable.pageNumber * pageable.pageSize)"
            @expand-change="expandHandler" @sort-change="onSort" :init-displayed-column="initDisplayedColumn"
            :default-sort = "{prop: 'dcName', order: 'descending'}"
            v-loading="loading" :row-class-name="tableRowClassName">
                <zm-table-column prop="expand" type="expand">
                    <template slot-scope="scope">
                        <channel-detail :id="scope.row.id"></channel-detail>
                    </template>
                </zm-table-column>
                <zm-table-column prop="dcName" label="dcName" align="center" show-overflow-tooltip sortable width="110px">
                </zm-table-column>
                <zm-table-column prop="channelName" label="clusterName" sortable show-overflow-tooltip>
                </zm-table-column>
                <!-- <zm-table-column prop="currentLoad" label="currentLoad" align="center" show-overflow-tooltip>
                </zm-table-column> -->
                <zm-table-column prop="sensitiveConfigurationType" label="sensitiveConfigurationType" align="center" show-overflow-tooltip width="210px">
                </zm-table-column>
                <zm-table-column prop="active" width="60px" label="active" align="center">
                    <template slot-scope='scope'>
                        <i class='glyphicon' :class="{'zm-icon-ok':scope.row.active,'zm-icon-close':!scope.row.active}"></i>
                    </template>
                </zm-table-column>
                <zm-table-column prop="endPoint" label="endPoint" align="center" show-overflow-tooltip>
                </zm-table-column>
                <zm-table-column prop="kafkaVersion" label="kafkaVersion" align="center" show-overflow-tooltip>
                </zm-table-column>
                <zm-table-column prop="createdTime" label="createdTime" align="center" :formatter="setTime" show-overflow-tooltip>
                </zm-table-column>
                <zm-table-column prop="modifiedTime" label="modifiedTime" align="center" :formatter="setTime" show-overflow-tooltip>
                </zm-table-column>
                <zm-table-column prop="operate" label="operate" width="150px">
                    <template slot-scope="scope">
                        <zm-button size="small" class="btn-contain" type="icon" title="edit cluster" icon="zm-icon-edit" v-if="hasPermission" @click="showEdit(scope.row)"></zm-button>
                        <zm-button size="small" class="btn-contain" type="icon" title="enable cluster" icon="zm-icon-play" v-if="!scope.row.active && hasPermission" @click="activeCluster(scope.row)"></zm-button>
                        <zm-button size="small" class="btn-contain" type="icon" title="disable cluster" icon="zm-icon-pause" v-if="scope.row.active && hasPermission" @click="activeCluster(scope.row)"></zm-button>
                        <zm-dropdown class="btn-contain" @command="handleCommand" trigger="click">
                            <zm-button type="icon" icon="zm-icon-more" class="btn-contain" :loading="scope.row.loading"></zm-button>
                            <zm-dropdown-menu slot="dropdown">
                                <zm-dropdown-item v-if="hasPermission"
                                    :command="{command: 'resetCluster', param: scope.row}">
                                    Reset Kafka
                                </zm-dropdown-item>
                                <zm-dropdown-item v-if="hasPermission"
                                    :command="{command: 'openUpload', param: scope.row}">
                                    Upload Kafka SSL JKS
                                </zm-dropdown-item>
                                <zm-dropdown-item :command="{command: 'showDescribe', param: scope.row}">
                                    Show Describe
                                </zm-dropdown-item>
                                <zm-dropdown-item v-if="role === 'SUPER_ADMIN' && !scope.row.active"
                                    :command="{command: 'deleteCluster', param: scope.row.id}">
                                    Delete Kafka
                                </zm-dropdown-item>
                                <zm-dropdown-item v-if="role === 'SUPER_ADMIN'"
                                    :command="{command: 'editBrokers', param: scope.row.id}">
                                    Edit Broker Config
                                </zm-dropdown-item>
                                <zm-dropdown-item v-if="role === 'SUPER_ADMIN'"
                                    :command="{command: 'generateDashboard', param: scope.row.id}">
                                    Generate Dashboard
                                </zm-dropdown-item>
                            </zm-dropdown-menu>
                        </zm-dropdown>
                    </template>
                </zm-table-column>
            </zm-table>
            <div style="text-align: center" class="pagination-wrap">
                <zm-pagination
                    @size-change="handleSizeChange"
                    :current-page.sync="pageable.pageNumber"
                    :page-size="pageable.pageSize"
                    :page-sizes="[2, 10, 20, 50, 100, 500, 1000]"
                    layout="sizes, total, prev, pager, next, jumper"
                    :total="tableData.length">
                </zm-pagination>
            </div>
        </div>
        <zm-dialog :title="form.title" :visible.sync="dialogFormVisible" @close="resetForm">
            <zm-form :model="form" label-position="left" ref="form" :rules="rules" :label-width="formLabelWidth">
                <zm-form-item label="clusterName" prop="channelName">
                    <div slot="label">
                        <tip label="clusterName" id="kafka-cluster-clusterName"></tip>
                    </div>
                    <zm-input size="small" v-model.trim="form.channelName" :disabled="form.title === 'Reset Kafka'"></zm-input>
                </zm-form-item>
                <zm-form-item label="clusterType" prop="clusterType" v-if="form.title !== 'Reset Kafka'">
                    <div slot="label">
                        <tip label="clusterType" id="kafka-cluster-clusterType"></tip>
                    </div>
                    <zm-radio-group size="small" v-model="form.clusterType">
                        <zm-radio label="AWS_EC2"></zm-radio>
                        <zm-radio label="AWS_MSK"></zm-radio>
                    </zm-radio-group>
                </zm-form-item>
                <zm-form-item label="endPoint" prop="endPoint">
                    <div slot="label">
                        <tip label="endPoint" id="kafka-cluster-endPoint"></tip>
                    </div>
                    <zm-input size="small" v-model.trim="form.endPoint" :disabled="form.title === 'Reset Kafka'"></zm-input>
                </zm-form-item>
                <zm-form-item label="dcName" prop="dcName" v-if="form.title !== 'Reset Kafka'">
                    <div slot="label">
                        <tip label="dcName" id="kafka-cluster-dcName"></tip>
                    </div>
                    <zm-input size="small" v-model="form.dcName"></zm-input>
                </zm-form-item>
                <zm-form-item label="Tags" prop="tags" v-if="form.title !== 'Reset Kafka'">
                    <div slot="label">
                        <tip label="tags" id="kafka-cluster-tags"></tip>
                    </div>
                    <zm-button size="small" @click="addTag" type="icon" icon="zm-icon-add" v-if="!tags.length">add config</zm-button>
                    <zm-table :data="tags">
                        <zm-table-column prop="key" label="key">
                            <template slot-scope="scope">
                                <zm-input size="small" v-model="scope.row.key" clearable>
                                </zm-input>
                            </template>
                        </zm-table-column>
                        <zm-table-column prop="value" label="value">
                            <template slot-scope="scope">
                                <zm-input size="small" v-model.trim="scope.row.value" clearable></zm-input>
                            </template>
                        </zm-table-column>
                        <zm-table-column width="100px">
                            <!-- eslint-disable-next-line -->
                            <template slot="header" slot-scope="scope">
                                <zm-button size="small" @click="addTag" type="icon" icon="zm-icon-add" :disabled="addDisabled">add parameter</zm-button>
                            </template>
                            <template slot-scope="scope">
                                <zm-button size="small" type="icon" icon="zm-icon-delete" @click="deleteTag(scope.row.key)"></zm-button>
                            </template>
                        </zm-table-column>
                    </zm-table>
                </zm-form-item>
                <zm-form-item label="sensitiveConfigurationType" label-width="200px" prop="sensitiveConfigurationType" v-if="form.title !== 'Edit Kafka'">
                    <div slot="label">
                        <tip label="sensitiveConfigurationType" id="kafka-cluster-sensitiveConfigurationType"></tip>
                    </div>
                    <zm-radio-group size="small" v-model="form.sensitiveConfigurationType">
                        <zm-radio label="LOCAL"></zm-radio>
                        <zm-radio label="CSMS"></zm-radio>
                    </zm-radio-group>
                </zm-form-item>
                <zm-form-item label="kafkaVersion" prop="kafkaVersion" v-if="form.title !== 'Reset Kafka'">
                    <div slot="label">
                        <tip label="kafkaVersion" id="kafka-cluster-kafkaVersion"></tip>
                    </div>
                    <zm-input size="small" v-model.trim="form.kafkaVersion"></zm-input>
                </zm-form-item>
                <zm-form-item label="userName" prop="userName" v-if="form.title !== 'Edit Kafka'">
                    <div slot="label">
                        <tip label="userName" id="kafka-cluster-userName"></tip>
                    </div>
                    <zm-input size="small" v-model.trim="form.userName"></zm-input>
                </zm-form-item>
                <zm-form-item label="password" prop="password" v-if="form.title !== 'Edit Kafka'">
                    <div slot="label">
                        <tip label="password" id="kafka-cluster-password"></tip>
                    </div>
                    <zm-input size="small" v-model="form.password"></zm-input>
                </zm-form-item>
                <zm-form-item label-width="0" prop="enableAlert" v-if="form.title !== 'Reset Kafka'">
                    <zm-checkbox v-model="form.enableAlert">
                        <tip label="enableAlert" id="kafka-cluster-enableAlert"></tip>
                    </zm-checkbox>
                </zm-form-item>
                <zm-form-item label-width="0" prop="enableJMX" v-if="form.title !== 'Reset Kafka'">
                    <zm-checkbox v-model="form.enableJMX">
                        <tip label="enableJMX" id="kafka-cluster-enableJMX"></tip>
                    </zm-checkbox>
                </zm-form-item>
                <zm-form-item label-width="0" prop="active" v-if="form.title !== 'Reset Kafka'">
                    <zm-checkbox v-model="form.active">
                        <tip label="active" id="kafka-cluster-active"></tip>
                    </zm-checkbox>
                </zm-form-item>
            </zm-form>
            <div slot="footer" class="dialog-footer">
                <zm-button size="small" @click="dialogFormVisible = false">Cancel</zm-button>
                <zm-button size="small" type="primary" @click="save()" :loading="loading">Submit</zm-button>
            </div>
        </zm-dialog>
        <zm-dialog title="Upload Client Trust Store File" :visible.sync="uploadVisible" width="600px">
            <zm-form :model="uploadData" label-position="left" ref="uploadData" :rules="uploadRules" label-width="140px">
                <zm-form-item label="clientSSLPassword" prop="clientSSLPassword">
                    <div slot="label">
                        <tip label="clientSSLPassword" id="channel-upload-clientSSLPassword"></tip>
                    </div>
                    <zm-input size="small" v-model="uploadData.clientSSLPassword"></zm-input>
                </zm-form-item>
                <zm-form-item label="sslEndPoint" prop="sslEndPoint">
                    <div slot="label">
                        <tip label="sslEndPoint" id="channel-upload-sslEndPoint"></tip>
                    </div>
                    <zm-input size="small" v-model="uploadData.sslEndPoint"></zm-input>
                </zm-form-item>
                <zm-form-item label-width="0" align="center">
                    <zm-upload
                        class="upload-demo"
                        drag
                        :action="getAction()"
                        :headers="headers"
                        :on-success="uploadSuccess"
                        :on-error="uploadError"
                        :data="uploadData"
                        ref="upload"
                        id="demo-upload"
                        :file-list="fileList"
                        :http-request="sslUpload"
                        :auto-upload="false">
                        <i class="zm-icon-upload"></i>
                        <div class="zm-upload__text">Drop file here or <em>click to upload</em></div>
                    </zm-upload>
                </zm-form-item>
            </zm-form>
            <div slot="footer" class="dialog-footer">
                <zm-button size="small" @click="uploadVisible = false">Cancel</zm-button>
                <zm-button size="small" style="margin-left: 10px;"  type="primary" @click="submitUpload" :loading="loading">Submit</zm-button>
            </div>
        </zm-dialog>
        <zm-dialog title="Upload From AsyncMQ" :visible.sync="mqVisible" append-to-body width="80%">
            <zm-table :data="mqClusters" v-loading="mqLoading" @selection-change="handleSelectionChange">
                <zm-table-column type="selection"></zm-table-column>
                <zm-table-column prop="dcName" label="dcName">
                    <template slot-scope="scope">
                        <zm-input v-model="scope.row.dcName"></zm-input>
                    </template>
                </zm-table-column>
                <zm-table-column prop="channelName" label="channelName">
                    <template slot-scope="scope">
                        <zm-input v-model="scope.row.channelName"></zm-input>
                    </template>
                </zm-table-column>
                <zm-table-column prop="tags" label="tags">
                    <template slot-scope="scope">
                        <zm-button @click="showTags(scope.row)" icon="zm-icon-edit" type="icon"></zm-button>
                        <div v-if="scope.row.tags">
                            <zm-tag v-for="item in Object.keys(scope.row.tags)" :key="item">{{ item }}: {{ scope.row.tags[item] }}</zm-tag>
                        </div>
                    </template>
                </zm-table-column>
                <zm-table-column prop="sensitiveConfigurationType" label="sensitiveConfigurationType"></zm-table-column>
                <zm-table-column prop="endPoint" label="endPoint" show-overflow-tooltip></zm-table-column>
            </zm-table>
            <div slot="footer" class="dialog-footer">
                <zm-button size="small" @click="mqVisible = false">Close</zm-button>
                <zm-button size="small" style="margin-left: 10px;"  type="primary" @click="submitUploadFromMq" :loading="mqLoading">Submit</zm-button>
            </div>
        </zm-dialog>
        <zm-dialog :visible.sync="tagVisible">
            <zm-button size="small" @click="addTag" type="icon" icon="zm-icon-add" v-if="!tags.length">add config</zm-button>
            <zm-table :data="tags">
                <zm-table-column prop="key" label="key">
                    <template slot-scope="scope">
                        <zm-input size="small" v-model="scope.row.key" clearable>
                        </zm-input>
                    </template>
                </zm-table-column>
                <zm-table-column prop="value" label="value">
                    <template slot-scope="scope">
                        <zm-input size="small" v-model.trim="scope.row.value" clearable></zm-input>
                    </template>
                </zm-table-column>
                <zm-table-column width="100px">
                    <!-- eslint-disable-next-line -->
                    <template slot="header" slot-scope="scope">
                        <zm-button size="small" @click="addTag" type="icon" icon="zm-icon-add" :disabled="addDisabled">add parameter</zm-button>
                    </template>
                    <template slot-scope="scope">
                        <zm-button size="small" type="icon" icon="zm-icon-delete" @click="deleteTag(scope.row.key)"></zm-button>
                    </template>
                </zm-table-column>
            </zm-table>
            <div slot="footer" class="dialog-footer">
                <zm-button @click="tagVisible = false">Cancel</zm-button>
                <zm-button type="primary" icon="zm-icon-ok" @click="closeTags">Save</zm-button>
            </div>
        </zm-dialog>
        <zm-dialog :visible.sync="brokerVisible">
            <zm-button size="small" @click="addParam" type="icon" icon="zm-icon-add" :disabled="addDisabled" v-if="!configs.length">add config</zm-button>
            <zm-table :data="configs" v-loading="brokerLoading">
                <zm-table-column prop="key" label="key">
                    <template slot-scope="scope">
                        <span v-if="!scope.row.isEdit">{{ scope.row.key }}</span>
                        <zm-select size="small" v-model="scope.row.key" v-else allow-create filterable clearable @change="setValue(scope.row)">
                            <zm-option v-for="item in selectableKeys" :key="item.key"
                                :value="item.key" :label="item.key"></zm-option>
                        </zm-select>
                    </template>
                </zm-table-column>
                <zm-table-column prop="value" label="value">
                    <template slot-scope="scope">
                        <span v-if="!scope.row.isEdit">{{ scope.row.value }}</span>
                        <zm-input size="small" v-model.trim="scope.row.value" v-else clearable></zm-input>
                    </template>
                </zm-table-column>
                <zm-table-column width="100px">
                    <!-- eslint-disable-next-line -->
                    <template slot="header" slot-scope="scope">
                        <zm-button size="small" @click="addParam" type="icon" icon="zm-icon-add" :disabled="addDisabled">add parameter</zm-button>
                    </template>
                    <template slot-scope="scope">
                        <zm-button size="small" type="icon" icon="zm-icon-edit" @click="scope.row.isEdit = true" v-if="!scope.row.isEdit"></zm-button>
                        <zm-button size="small" type="icon" icon="zm-icon-ok" v-else
                            @click="scope.row.isEdit = false" :disabled="!scope.row.value.length || !scope.row.key.length"></zm-button>
                        <zm-button size="small" type="icon" icon="zm-icon-delete"
                            @click="deleteParam(scope.row.key)"></zm-button>
                    </template>
                </zm-table-column>
            </zm-table>
            <div slot="footer" class="dialog-footer">
                <zm-button @click="brokerVisible = false">Cancel</zm-button>
                <zm-button type="primary" icon="zm-icon-ok" @click="saveBroker" :loading="loading">Save</zm-button>
            </div>
        </zm-dialog>
        <zm-dialog :visible.sync="searchVisible" title="Search By Tags">
            <zm-table :data="searchTags" max-height="300">
                <zm-table-column prop="key" label="key">
                    <template slot-scope="scope">
                        <span v-if="!scope.row.isEdit">{{ scope.row.key }}</span>
                        <zm-input size="small" v-model="scope.row.key" v-else></zm-input>
                    </template>
                </zm-table-column>
                <zm-table-column prop="value" label="value">
                    <template slot-scope="scope">
                        <span v-if="!scope.row.isEdit">{{ scope.row.value }}</span>
                        <zm-input size="small" v-model.trim="scope.row.value" v-else></zm-input>
                    </template>
                </zm-table-column>
                <zm-table-column width="100px">
                    <!-- eslint-disable-next-line -->
                    <template slot="header" slot-scope="scope">
                        <zm-button size="small" @click="addTagParam" type="icon" icon="zm-icon-add" :disabled="addSearchDisabled">add parameter</zm-button>
                    </template>
                    <template slot-scope="scope">
                        <zm-button size="small" type="icon" icon="zm-icon-edit" @click="scope.row.isEdit = true" v-if="!scope.row.isEdit"></zm-button>
                        <zm-button size="small" type="icon" icon="zm-icon-ok" v-else
                            @click="scope.row.isEdit = false" :disabled="!scope.row.value.length || !scope.row.key.length"></zm-button>
                        <zm-button size="small" type="icon" icon="zm-icon-delete"
                            @click="deleteTagParam(scope.row.key)"></zm-button>
                    </template>
                </zm-table-column>
            </zm-table>
            <div slot="footer" class="dialog-footer">
                <zm-button @click="searchVisible = false">Cancel</zm-button>
                <zm-button type="primary" icon="zm-icon-ok" @click="searchClusterByTags" :loading="loading">Save</zm-button>
            </div>
        </zm-dialog>
    </div>
</template>
<script>
import { listCluster, createCluster, resetCluster, updateCluster, activeCluster, deleteCluster,
uploadSSL, uploadFromMq, listBrokerConfigItems, updateConfigBrokers, getClusterById, getBrokerConfig,
searchClusterByTags } from '@/api/kafkaManage'
import { listChannelWithCredential } from '@/api'
import tip from 'components/ToolTip/index'
import channelDetail from './clusterDetail'
import axios from 'axios'
export default {
    name: 'kafkaCluster',
    components: {
        tip,
        channelDetail
    },
    data () {
        return {
            role: localStorage.role,
            hasPermission: localStorage.role === 'SUPER_ADMIN' || localStorage.role === 'ADMIN',
            initDisplayedColumn: {
                key: 'kafkacluster',
                props: ['expand', 'dcName', 'channelName', 'sensitiveConfigurationType', 'active', 'endPoint', 'operate']
            },
            loading: false,
            list: [],
            searchTags: [
                {
                    key: '',
                    value: '',
                    isEdit: true
                }
            ],
            searchVisible: false,
            search: '',
            dialogFormVisible: false,
            formLabelWidth: '130px',
            pageable: {
                pageNumber: 1,
                pageSize: 10,
                total: 0
            },
            form: {
                id: '',
                active: true,
                channelName: '',
                clusterType: '',
                dcName: '',
                enableAlert: true,
                enableJMX: true,
                endPoint: '',
                kafkaVersion: '',
                password: '',
                sensitiveConfigurationType: '',
                userName: ''
            },
            fileList: [],
            uploadVisible: false,
            uploadData: {
                channelId: '',
                clientSSLPassword: '',
                sslEndPoint: ''
            },
            headers: {
                'Authorization': `Bearer ` + localStorage.token
            },
            mqClusters: [],
            selecstedMqClusters: [],
            mqLoading: false,
            mqVisible: false,
            configs: [],
            tags: [],
            mqRowChannelId: '',
            tagVisible: false,
            defaultConfigs: [],
            brokerVisible: false,
            brokerLoading: false,
            brokerForm: {
                configs: {},
                channelId: ''
            },
            uploadRules: {
                clientSSLPassword: [
                    { required: true, message: 'please enter clientSSLPassword', trigger: 'blur' }
                ],
                sslEndPoint: [
                    { required: true, message: 'please enter sslEndPoint', trigger: 'blur' }
                ]
            },
            rules: {
                userName: [
                    { required: true, message: 'please enter userName', trigger: 'blur' }
                ],
                password: [
                    { required: true, message: 'please enter password', trigger: 'blur' }
                ],
                channelName: [
                    { required: true, message: 'please enter clusterName', trigger: 'blur' }
                ],
                endPoint: [
                    { required: true, message: 'please enter endPoint', trigger: 'blur' }
                ],
                dcName: [
                    { required: true, message: 'please enter dcName', trigger: 'blur' }
                ],
                sensitiveConfigurationType: [
                    { required: true, message: 'please choose a sensitiveConfigurationType', trigger: 'blur' }
                ],
                clusterType: [
                    { required: true, message: 'please choose a clusterType', trigger: 'blur' }
                ]
            }
        }
    },
    watch: {
        search () {
            this.setURL()
        }
    },
    created () {
        if (localStorage.params && localStorage.params !== 'undefined' && localStorage.path === this.$route.path && localStorage.path === this.$route.path) {
            this.search = JSON.parse(localStorage.params).search
        }
        this.fetchData()
        localStorage.params = ''
        localStorage.path = this.$route.path
    },
    computed: {
        tableData () {
            if (this.search) {
                return this.list.filter(data => {
                    return Object.keys(data).some(key => {
                        return String(data[key]).toLowerCase().indexOf(this.search.toLowerCase()) > -1
                    })
                })
            }
            return this.list
        },
        selectableKeys () {
            let data = JSON.parse(JSON.stringify(this.defaultConfigs))
            this.configs.map(item => {
                data.map(j => {
                    if (item.key === j.key) {
                        data.splice(data.indexOf(j), 1)
                    }
                })
            })
            return data
        },
        addDisabled () {
            let data = false
            this.configs.map(item => {
                if (item.isEdit) {
                    data = true
                }
            })
            return data
        },
        addSearchDisabled () {
            let data = false
            this.searchTags.map(item => {
                if (item.isEdit) {
                    data = true
                }
            })
            return data
        }
    },
    methods: {
        setTime (row, column, cellValue, index) {
            return new Date(parseInt(cellValue)).toLocaleString()
        },
        setURL () {
            const { search } = this
            const data = { path: this.$route.path, search }
            localStorage.path = this.$route.path
            localStorage.params = JSON.stringify(data)
        },
        save () {
            var tagValid = true
            const tags = {}
            this.tags.map(item => {
                if (tags[item.key] !== undefined) {
                    tagValid = false
                }
                tags[item.key] = item.value
            })
            this.$refs.form.validate((valid) => {
                if (valid && tagValid) {
                    this.loading = true
                    const { id, channelName, dcName, endPoint, userName, password, sensitiveConfigurationType, active, clusterType, enableAlert, enableJMX, kafkaVersion } = this.form
                    const data = { id, channelName, dcName, endPoint, userName, password, sensitiveConfigurationType, active, clusterType, enableAlert, enableJMX, kafkaVersion, tags }
                    if (this.form.title === 'Create Kafka') {
                        createCluster(data).then(response => {
                            this.fetchData()
                            this.$message({
                                message: 'Submit create kafka success!',
                                type: 'success'
                            })
                            this.dialogFormVisible = false
                            this.$refs.form.resetFields()
                        }).catch(() => {
                            this.loading = false
                        })
                    } else if (this.form.title === 'Reset Kafka') {
                        resetCluster(data).then(response => {
                            this.fetchData()
                            this.$message({
                                message: 'Reset kafka success!',
                                type: 'success'
                            })
                            this.dialogFormVisible = false
                            this.$refs.form.resetFields()
                        }).catch(() => {
                            this.loading = false
                        })
                    } else if (this.form.title === 'Edit Kafka') {
                        updateCluster(data).then(response => {
                            this.fetchData()
                            this.$message({
                                message: 'Update kafka success!',
                                type: 'success'
                            })
                            this.dialogFormVisible = false
                            this.$refs.form.resetFields()
                        }).catch(() => {
                            this.loading = false
                        })
                    }
                } else if (!tagValid) {
                    this.$message({
                        message: 'Key of tag cannot be duplicated',
                        type: 'error'
                    })
                } else {
                    this.loading = false
                    this.$message({
                        message: 'Submit error!',
                        type: 'error'
                    })
                    return false
                }
            })
        },
        onSort ({ column, prop, order }) {
            const descending = order === 'descending'
            this.list.sort((a, b) => {
            if (a[prop] > b[prop]) {
                return descending ? -1 : 1
            } else if (a[prop] < b[prop]) {
                return descending ? 1 : -1
            } else {
                return 0
            }
            })
        },
        showMQ () {
            this.mqLoading = true
            listChannelWithCredential().then(res => {
                this.mqClusters = res
                this.mqVisible = true
                this.mqLoading = false
            }).catch(() => {
                this.mqLoading = false
            })
        },
        showTags (row) {
            this.tags = []
            this.mqRowChannelId = row.channelId
            if (row.tags) {
                this.tags = Object.keys(row.tags).map(item => {
                    return {
                        key: item,
                        value: row.tags[item]
                    }
                })
            }
            this.tagVisible = true
        },
        addTag () {
            this.tags.unshift({
                key: '',
                value: ''
            })
        },
        deleteTag (key) {
            if (key) {
                this.tags.map((item, index, arr) => {
                    if (item.key === key) {
                        this.tags.splice(index, 1)
                    }
                })
            } else {
                this.tags.shift()
            }
        },
        closeTags () {
            const tags = {}
            this.tags.map(item => {
                tags[item.key] = item.value
            })
            this.mqClusters.map(item => {
                if (item.channelId === this.mqRowChannelId) {
                    item.tags = tags
                }
            })
            this.tagVisible = false
        },
        submitUploadFromMq () {
            this.mqLoading = true
            uploadFromMq(this.selecstedMqClusters).then(res => {
                this.$message.success('Upload success')
                this.fetchData()
                this.mqVisible = false
                this.mqLoading = false
            }).catch(() => {
                this.mqLoading = false
            })
        },
        handleSelectionChange (val) {
            this.selecstedMqClusters = val
        },
        showCreate () {
            this.form.title = 'Create Kafka'
            this.form.id = ''
            this.form.channelName = ''
            this.form.dcName = ''
            this.form.endPoint = ''
            this.form.userName = ''
            this.form.password = ''
            this.form.sensitiveConfigurationType = ''
            this.form.clusterType = ''
            this.form.enableAlert = ''
            this.form.enableJMX = ''
            this.form.kafkaVersion = ''
            this.tags = []
            this.dialogFormVisible = true
        },
        showEdit (row) {
            this.form.title = 'Edit Kafka'
            this.form.id = row.id
            this.form.channelName = row.channelName
            this.form.dcName = row.dcName
            this.form.endPoint = row.endPoint
            this.form.userName = row.userName
            this.form.password = row.password
            this.form.sensitiveConfigurationType = row.sensitiveConfigurationType
            this.form.clusterType = row.clusterType
            this.form.enableAlert = row.enableAlert
            this.form.enableJMX = row.enableJMX
            this.form.kafkaVersion = row.kafkaVersion
            this.tags = []
            if (row.tags) {
                this.tags = Object.keys(row.tags).map(item => {
                    return {
                        key: item,
                        value: row.tags[item]
                    }
                })
            }
            this.dialogFormVisible = true
        },
        resetCluster (row) {
            this.form.title = 'Reset Kafka'
            this.form.id = row.id
            this.form.channelName = row.channelName
            this.form.dcName = row.dcName
            this.form.endPoint = row.endPoint
            this.form.userName = row.userName
            this.form.password = row.password
            this.form.sensitiveConfigurationType = row.sensitiveConfigurationType
            this.form.clusterType = row.clusterType
            this.form.enableAlert = row.enableAlert
            this.form.enableJMX = row.enableJMX
            this.form.kafkaVersion = row.kafkaVersion
            this.tags = []
            if (row.tags) {
                this.tags = Object.keys(row.tags).map(item => {
                    return {
                        key: item,
                        value: row.tags[item]
                    }
                })
            }
            this.dialogFormVisible = true
        },
        expandHandler (row, expandedRows) {
        },
        getAction () {
            return process.env.VUE_APP_API_URL + '/api/v1/manage/kafka_cluster/upload/truststore'
        },
        sslUpload (content) {
            const { channelId, clientSSLPassword, sslEndPoint } = this.uploadData
            const data = { channelId, clientSSLPassword, sslEndPoint }
            const formData = new FormData()
            formData.append('file', content.file)
            Object.keys(data).map(item => {
                if (data[item] !== null) {
                    formData.append(item, data[item])
                }
            })
            this.loading = true
            axios({
                method: 'post',
                url: content.action,
                headers: content.headers,
                data: formData
            }).then(res => {
                this.loading = false
                content.onSuccess(res)
            }).catch(err => {
                this.loading = false
                content.onError(err)
            })
        },
        openUpload (row) {
            this.uploadData.channelId = row.channelId
            this.uploadData.clientSSLPassword = ''
            this.uploadData.sslEndPoint = ''
            this.uploadVisible = true
        },
        submitUpload () {
            if (this.$refs.upload.uploadFiles.length) {
                this.$refs.upload.submit()
            } else {
                const { channelId, clientSSLPassword, sslEndPoint } = this.uploadData
                const data = { channelId, clientSSLPassword, sslEndPoint }
                const formData = new FormData()
                Object.keys(data).map(item => {
                    if (data[item] !== null) {
                        formData.append(item, data[item])
                    }
                })
                this.loading = true
                uploadSSL(formData).then(response => {
                    this.loading = false
                    this.uploadVisible = false
                    this.$message.success('Update success')
                }).catch(() => {
                    this.loading = false
                })
            }
        },
        uploadSuccess (response, file) {
            this.loading = false
            if (response.data.success) {
                this.uploadVisible = false
                this.$message({
                    message: 'Upload success!',
                    type: 'success'
                })
                this.$refs.upload.clearFiles()
                this.fetchData()
            } else {
                this.$message({
                    message: response.body.errorMessage,
                    type: 'error'
                })
            }
        },
        uploadError (err, file) {
            this.loading = false
            this.$message({
                message: err.response.data.message,
                type: 'error'
            })
        },
        resetForm () {
            this.$refs.form.resetFields()
        },
        showSearch () {
            this.searchVisible = true
        },
        deleteTagParam (key) {
            if (key) {
                this.searchTags.map((item, index, arr) => {
                    if (item.key === key) {
                        this.searchTags.splice(index, 1)
                    }
                })
            } else {
                this.searchTags.shift()
            }
        },
        addTagParam () {
            this.searchTags.unshift({
                key: '',
                value: '',
                isEdit: true
            })
        },
        searchClusterByTags () {
            var searchTags = {}
            this.searchTags.map(item => {
                if (item.value !== '') {
                    searchTags[item.key] = item.value
                }
            })
            this.loading = true
            searchClusterByTags(searchTags).then(res => {
                this.list = res
                this.searchVisible = false
                this.loading = false
            }).catch(() => {
                this.loading = false
            })
        },
        fetchData () {
            this.loading = true
            listCluster().then(res => {
                this.list = res
                this.loading = false
            }).catch(() => {
                this.loading = false
            })
        },
        tableRowClassName ({ row, rowIndex }) {
            if (!row.active) {
                return 'warning-row'
            // } else if (!row.active && !row.nodeInfos) {
            //     return 'warning-row hide-expand'
            // } else if (row.active && !row.nodeInfos) {
            //     return 'hide-expand'
            } else {
                return ''
            }
        },
        handleSizeChange (val) {
            this.pageable.pageSize = val
        },
        activeCluster (row) {
            this.loading = true
            this.$confirm('This will change the status. Continue?', 'Warning', {
                confirmButtonText: 'Change',
                cancelButtonText: 'Cancel',
                type: 'warning'
            }).then(() => {
                this.loading = true
                activeCluster(row.id, !row.active).then(response => {
                    this.fetchData()
                    this.$message({
                        message: 'Change status success!',
                        type: 'success'
                    })
                }).catch(() => {
                    this.loading = false
                })
            }).catch(() => {
                this.loading = false
                this.$message({
                    type: 'info',
                    message: 'Change canceled'
                })
            })
        },
        deleteCluster (id) {
            this.loading = true
            this.$confirm('This will delete the cluster. Continue?', 'Warning', {
                confirmButtonText: 'Delete',
                cancelButtonText: 'Cancel',
                type: 'warning'
            }).then(() => {
                this.loading = true
                deleteCluster(id).then(response => {
                    this.fetchData()
                    this.$message({
                        message: 'Delete success!',
                        type: 'success'
                    })
                }).catch(() => {
                    this.loading = false
                })
            }).catch(() => {
                this.loading = false
                this.$message({
                    type: 'info',
                    message: 'Delete canceled'
                })
            })
        },
        showEditBrokers (id) {
            this.configs = []
            this.brokerForm.channelId = id
            this.brokerVisible = true
            this.brokerLoading = true
            getClusterById(id).then(response => {
                if (response.nodeInfos) {
                    const runningBroker = response.nodeInfos.filter(data => {
                        return data.nodeStatus === 'RUNNING'
                    })
                    var brokerId = runningBroker.length ? runningBroker[0].id : ''
                    if (brokerId) {
                        getBrokerConfig(id, brokerId).then(res => {
                            this.brokerLoading = false
                            this.configs = Object.keys(res.configs).map(item => {
                                return {
                                    key: item,
                                    value: res.configs[item]
                                }
                            })
                        }).catch(() => {
                            this.brokerLoading = false
                        })
                    } else {
                        this.brokerLoading = false
                        this.$message.warning('No RUNNING node!')
                    }
                }
            }).catch(() => {
                this.brokerLoading = false
            })
            listBrokerConfigItems().then(response => {
                this.defaultConfigs = []
                Object.keys(response.configItems).map(item => {
                    this.defaultConfigs.push({
                        key: item,
                        value: response.configItems[item],
                        isEdit: false
                    })
                })
            })
        },
        setValue (row) {
            if (row.key) {
                this.defaultConfigs.map(item => {
                    if (row.key === item.key) {
                        row.value = item.value
                    }
                })
            }
        },
        addParam () {
            this.configs.unshift({
                key: '',
                value: '',
                isEdit: true
            })
        },
        deleteParam (key) {
            if (key) {
                this.configs.map((item, index, arr) => {
                    if (item.key === key) {
                        this.configs.splice(index, 1)
                    }
                })
            } else {
                this.configs.shift()
            }
        },
        saveBroker () {
            this.brokerForm.configs = {}
            this.configs.map(item => {
                this.brokerForm.configs[item.key] = item.value
            })
            this.loading = true
            updateConfigBrokers(this.brokerForm.channelId, this.brokerForm.configs).then(response => {
                this.loading = false
                this.fetchData()
                this.brokerVisible = false
            }).catch(() => {
                this.loading = false
            })
        },
        handleCommand (command) {
            if (command.command === 'resetCluster') {
                this.resetCluster(command.param)
            } else if (command.command === 'openUpload') {
                this.openUpload(command.param)
            } else if (command.command === 'showDescribe') {
                localStorage.setItem('channelName', command.param.channelName)
                this.$router.push('/dashboard/manage/cluster/describe/' + command.param.channelId)
            } else if (command.command === 'showRecovery') {
                this.showRecovery(command.param)
            } else if (command.command === 'deleteCluster') {
                this.deleteCluster(command.param)
            } else if (command.command === 'editBrokers') {
                this.showEditBrokers(command.param)
            } else if (command.command === 'generateDashboard') {
                this.$router.push('/dashboard/manage/generate/' + command.param)
            }
        }
    }
}
</script>
<style>
.btn-contain.zm-dropdown {
    margin: 10px;
    display: inline;
}
.btn-in-line{
    margin: 10px;
}
.search-input{
    float: right;
    margin: 10px;
    width: 200px;
}
</style>
